module.exports = __webpack_public_path__ + "static/img/lxwm.366f020a.png";